import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useSelector } from "react-redux";
import { apiData } from "../../../actions";
import DataLoader from "../../../Utils/DataLoader";

export default function HomeFlight() {
    const [flightDeals, setFlightDeals] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);

    const place = useSelector((state) => state.place);

    const CoolFlightDeals = async () => {
        try {
            setPageLoading(true);
            let apiRes = await apiData.coolFlightDeals();

            if (apiRes?.status >= 200 && apiRes?.status <= 399) {
                setFlightDeals(apiRes?.data?.data || []);
            } else {
                console.log("API Error");
            }
        } catch (err) {
            console.log("Error fetching deals:", err);
        } finally {
            setPageLoading(false);
        }
    };

    useEffect(() => {
        CoolFlightDeals();
    }, [place]);

    if (pageLoading) return <DataLoader />;

    return (
        <section className="section-equal-padding bg-white">
            <div className="container-fluid">
                <div className="row mb-3 mb-md-5">
                    <div className="col-12 col-sm-12 col-md-4 col-lg-6">
                        <div className="section-top-heading mb-1 mb-md-3" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                            <h2>Flight Specials</h2>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-8 col-lg-6">
                        <div className="section-top-heading" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                            <p>Our Flight Specials make it all possible! Score unbeatable airfare deals, turn your travel dreams into reality, and let's make some epic memories together. Come on, let's take flight and create unforgettable experiences!</p>
                        </div>
                    </div>
                </div>

                <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    loop={true}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    navigation={true}
                    breakpoints={{
                        0: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        992: { slidesPerView: 3 },
                        1400: { slidesPerView: 4 },
                    }}
                    className="excitement-swiper flightSlider pb-70" 
                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
                >

                    {flightDeals.map((deal, index) => (
                        <SwiperSlide key={index}>
                            <div className="special-card-box flight_image">
                                <figure>
                                    <a href={deal.url} target="_blank" rel="noreferrer">
                                        <img loading="lazy" src={deal.image_url} alt="Deal" />
                                    </a>
                                </figure>

                                <div className="specialCard-content">
                                    <h3>{deal.title}</h3>
                                    <a href={deal.url} target="_blank" rel="noreferrer">
                                        Book Trip <i className="fa-solid fa-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}

                </Swiper>

            </div>
        </section>
    )
}
